import React, { useState, useEffect } from "react";
import { Stack, Box, styles, Input, Button, Card, CardContent, Typography, CardActions } from "@mui/material";
import { theme, Badge } from "@material-ui/core";
import FormUsers from "../form/FormUsers.jsx";
import Child from "../form/Child.jsx";
import CompanyRegister from "../form/CompanyRegister.jsx";
//CompanyRegisterTable
import CompanyRegisterTable from "../form/CompanyRegisterTable.jsx";

export default function FormUsersCont (){
   
    const [weatherData, setWeatherData] = useState([]);
    const [dataFromChild, setDataFromChild]=useState('');
    
    const [topButtonCompanyLabel, setTopButtonCompanyLabel]=useState('SHOW COMPANY FORM');
    const [showCompanyRegister, setShowCompanyRegister]=useState(true)
    const handleButtonClick = () =>{
      if(showCompanyRegister===false){
        setShowCompanyRegister(true);
        setTopButtonCompanyLabel("SHOW COMPANY FORM")
      }
      else{
        setShowCompanyRegister(false);
        setTopButtonCompanyLabel("SHOW COMPANY TABLE")
      }
    }
    
    const handleData=(data)=>{
      console.log("dataQQQ=" + data);
      setDataFromChild(data)
    }
    
    return(
      <Box m="20px">
        <div sx={{marginBottom: "10px", marginLeft: "5px;"}} >
        <Button onClick={handleButtonClick} color="secondary" variant="contained">{topButtonCompanyLabel}</Button>
        </div>
        <br/>
        <div sx={{marginTop: "30px;"}}>
         {showCompanyRegister && (<CompanyRegister />)}
        </div>
        <br/>
        <div sx={{marginTop: "30px", marginBottom: "30px"}}>
          {
            !showCompanyRegister && (
              <CompanyRegisterTable/>
            )
          }
        </div>
        <br/>
        <div sx={{marginTop: "30px;"}}>
        
        {
            (<FormUsers />)
        }
        </div>
       <br/>
       {/*** sendDataToParent={handleGetDataFromChild}**/}
       <h4>Data from Child: {dataFromChild}</h4>
       <Child sendDataToParent={handleData}/>
       <br/>
       <Card sx={{ minWidth: 275 }}>
      <CardContent>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          Word of the Day
        </Typography>
        <Typography variant="h5" component="div">
          
        </Typography>
        <Typography sx={{ mb: 1.5 }} color="text.secondary">
          adjective
        </Typography>
        <Typography variant="body2">
          well meaning and kindly.
          <br />
          {'"a benevolent smile"'}
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small">Learn More</Button>
      </CardActions>
    </Card>
      </Box>  
    )
}